import dataService from 'services/dataService';
import {
  API_CCM_MESSAGES,
  API_PATIENTS_MESSAGES,
} from 'services/dataService/resources';
import { showResult } from 'infrastructure/hooks/utils';

import type { DigitalEngagementType } from 'infrastructure/data-sources/digital-engagement';

export interface ISendSmsDataProps {
  patientGuid: string;
  topic: string;
  type: 'sms';
  message: string;
  isRpmPanel: boolean;
  isPrimaryNumber: boolean;
  timerDuration: number | null;
  trackerGuid: string | null;
  digitalEngagement?: DigitalEngagementType;
}

export const sendSmsFn = async ({
  isRpmPanel,
  ...other
}: ISendSmsDataProps): Promise<{ error: null | string }> => {
  const endpoint = isRpmPanel ? API_PATIENTS_MESSAGES : API_CCM_MESSAGES;
  const { error } = await dataService.createOne(endpoint, other);

  if (error) {
    showResult(error);
    return { error };
  }

  return { error: null };
};
